import React from 'react';

import Section from 'components/Section';
import Block from 'ui/block';
import {CONTACT_EMAIL} from 'app/const';
import COVER_PHOTO from 'img/footer-cover-2.jpg';

import styles from './index.module.scss';


const ADDRESS = (
    <div>
        <strong>Reinvent Software</strong><br/>
        The Hatch Lab<br/>
        M11 Business Campus<br/>
        Y25&nbsp;A8H2 Gorey<br/>
        Co. Wexford, Ireland
    </div>
);


export default function SiteFooter() {

    const sectionStyle = {
        backgroundImage: `url(${COVER_PHOTO})`,
        backgroundSize: 'auto',
        backgroundPosition: 'center bottom',
        backgroundAttachment: 'fixed',
        // backgroundRepeat: 'no-repeat',
    };

    return <Section theme="darker" style={sectionStyle}>
        <Block>

            <div className={styles.footerRow}>

                <div className={styles.cell}>
                    {ADDRESS}
                </div>

                <div className={styles.cell}>
                    <h3>Get in touch</h3>
                    Drop us an email at{' '}
                    <a href={`mailto:${CONTACT_EMAIL}`}>
                        {CONTACT_EMAIL}
                    </a>
                </div>

                <div className={styles.cell}>
                </div>

            </div>
        </Block>
    </Section>;
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.js